import { render, staticRenderFns } from "./VueTree.vue?vue&type=template&id=3da88991&scoped=true"
import script from "./VueTree.vue?vue&type=script&lang=js"
export * from "./VueTree.vue?vue&type=script&lang=js"
import style0 from "./VueTree.vue?vue&type=style&index=0&id=3da88991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da88991",
  null
  
)

export default component.exports